var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9426 13.5552H9.65045C5.03386 13.5552 1.30408 17.2614 1.30408 21.8489C1.30408 26.4364 5.03386 30.1427 9.65045 30.1427H40.3495C44.966 30.1427 48.6958 33.8489 48.6958 38.4364C48.6958 43.0239 44.966 46.7301 40.3495 46.7301H2.58212",
    stroke: "#352890",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6786 8.19019H31.0902C30.5284 8.19019 30.073 8.64274 30.073 9.20098V17.8576C30.073 18.4158 30.5284 18.8684 31.0902 18.8684H47.6786C48.2404 18.8684 48.6958 18.4158 48.6958 17.8576V9.20098C48.6958 8.64274 48.2404 8.19019 47.6786 8.19019Z",
    stroke: "#352890",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1768 1.2959L45.6703 8.19007",
    stroke: "#352890",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCables);
export default __webpack_public_path__ + "static/media/Cables.782d9d89f1db5bf19e42a962e6a6a483.svg";
export { ForwardRef as ReactComponent };